import { all } from 'redux-saga/effects'

import PlanSagas from '../plan/sagas'

export default class ShoppingListSagas {
  static *init() {
    yield
    return
  }

  static *load() {
    // const { id } = query

    // if (id) {
    //   yield PlanSagas.loadPlan(id)
    // }

    yield PlanSagas.loadCurrentPlan()
  }

  static *loop() {
    yield all([
      //
    ])
  }
}
